import { PrivilegeModel } from './privilege.model';
// Author: Da Do
// This model is only used for Privilege User Role. Please do not use for other feature.

export class ListPrivilegeModel {
    ListOfPrivilegeViewModel: PrivilegeModel[] = [];
}
